module.exports = __webpack_public_path__ + "static/media/2_The inner voice_TI.6e38068a.txt";